<template>
  <div class="my_collection">
    <div class="tit">
      <span>设置默认企业/园区</span>
    </div>
    <div class="body_content">
      <el-form
        :model="form"
        ref="ruleForm"
        status-icon
        label-width="120px"
        label-position="left"
        v-if="list.length"
      >
        <el-form-item label="设置默认企业为">
          <el-select v-model="form.enterprise_id" placeholder="请选择企业" @change="selceted">
            <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置默认园区为">
          <el-select v-model="form.incubator_id" placeholder="请选择园区">
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="notarize" type="primary" @click="submit('default')">设置默认园区</el-button>
<!--          <el-button class="notarize" type="primary" @click="submit('change')">切换园区</el-button>-->
        </el-form-item>
      </el-form>
      <div v-else>
        您还没有身份认证
        <el-button type="primary" @click="go('employee_certification_table_list');">员工认证</el-button>
        <el-button type="primary" @click="go('enterprise_certificaiton_table_list');">企业认证</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        enterprise_id: "",
        incubator_id: ""
      },
      list: [], //企业
      list2: [] //园区
    };
  },
  created() {
    this.getUserEnterprise(); //查询已认证企业
  },
  methods: {
    /*提交用户信息*/
    submit(type){
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          // type === 'default' && this.setUserDefaultIncubator();
          // type === 'change' && this.setUserSelectIncubator();
          this.setIncubator();
          /* 更新用户信息 */
        } else {
          return false;
        }
      });
    },
    async setIncubator(){
      await this.setUserDefaultIncubator();
      // await this.setUserSelectIncubator();
      this.common.getParkInfo(true);
      this.common.getEnterpriseInfo();
    },
    // 切换当前企业园区
    setUserSelectIncubator() {
      let params = {
        enterprise_id: this.form.enterprise_id,
        incubator_id: this.form.incubator_id
      };
      return this.api.setUserSelectIncubator(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message.success('设置成功！');
        // this.common.getParkInfo(true);
        // window.location.reload(true);
      });
    },
    // 设置默认企业园区
    setUserDefaultIncubator() {
      let params = {
        enterprise_id: this.form.enterprise_id,
        incubator_id: this.form.incubator_id
      };
      return this.api.setUserDefaultIncubator(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.$alert('设置默认企业/园区后需要退出重新登录园区无忧才可以看到哦', '设置成功', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        // this.$message.success('设置成功！');
        // this.common.getEnterpriseInfo();
        // this.common.getParkInfo(true);
      });
    },
    // 选择企业
    selceted(val) {
      this.getIncubators();
    },
    // 根据企业查询园区
    getIncubators() {
      let params = {
        enterprise_id: this.form.enterprise_id,
        pageNo: 0,
        pageSize: 99
      };
      this.api.getUserIncubator(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list2 = res.obj.list || [];
        this.list2 = list2;
        list2.forEach(item => {
          if (item.is_default) {
            this.form.incubator_id = item.id;
          }
        });
      });
    },
    //查询已认证企业
    getUserEnterprise() {
      this.api.getUserEnterprise().then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list || [];
        list.forEach(item => {
          if (item.is_default) {
            this.form.enterprise_id = item.id;
            this.getIncubators();
          }
        });
        this.list = list;
      });
    },
    /*页面跳转*/

    go(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
